<template>
  <div class="category-card-1-1 btn btn-primary rounded-pill">
    <span>{{ category.name }}</span>
  </div>
</template>

<script>
import mA from '../../Tags/A'

export default {
  name: "CategoryCard",
  components: {mA,},
  props: {
    category: {}
  }
}
</script>

<style scoped>

</style>